<template>
  <transition name="message-fade">
    <div class="message" :class="typeClass" role="alert" v-show="visible">
      <p class="message__content">
        <!-- <v-icon large :color="color" small>{{ icon }}</v-icon> -->&nbsp;{{
          message
        }}
      </p>
    </div>
  </transition>
</template>
<script>
export default {
  name: "cus_message",
  data() {
    return {
      visible: false,
      duration: 5000,
      message: "",
      timer: null,
      closed: false,
      color: "",
      icon: "",
      typeClass: "",
    };
  },
  watch: {
    closed(val) {
      if (val) {
        this.visible = false;
        this.$el.addEventListener("transitionend", this.destroyElement);
      }
    },
  },
  methods: {
    destroyElement() {
      this.$el.removeEventListener("transitionend", this.destroyElement);
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.close();
          }
        }, this.duration);
      }
    },
    close() {
      this.closed = true;
    },
  },
  mounted() {
    this.startTimer();
  },
};
</script>
<style scoped>
.message {
  min-width: 250px;
  box-sizing: border-box;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  position: fixed;
  left: 50%;
  top: 10px;
  transform: translateX(-50%);
  transition: opacity 0.3s, transform 0.4s;
  overflow: hidden;
  padding: 15px 15px 15px 20px;
  display: flex;
  align-items: center;
}

.message--success {
  background-color: #2BA471;
  border-color: #2BA471;
  color: #ffffff;
}

.message--error {
  background-color: #FF0000;
  border-color: #FF0000;
  color: #ffffff;
}

.message--warning {
  background-color: #FFFFE0;
  border-color: #FFFFE0;
  color: #000000;
}

.message p {
  margin: 0;
}

.message__content {
  padding: 0;
  font-size: 14px;
  line-height: 1;
}

.message-fade-enter,
.message-fade-leave-active {
  opacity: 0;
  transform: translate(-50%, -100%);
}
</style>
